import { Button, Card } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FullPageLoader from "../../components/Loaders/FullPageLoader";
import { translate } from "../../locale";
import AuthServices from "../../services/AuthServices";

const ForgotPasswordVerificationCode = () => {
  const { username, code } = useParams();
  const [validating, setValidating] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [info, setInfo] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const verifyData = async () => {
      setSuccess("");
      setError("");
      try {
        const response = await AuthServices.forgotPasswordCode({
          username,
          code,
        });
        if (response.status >= 200 && response.status < 300) {
          setSuccess(
            <>
              {translate(
                "Su contraseña ha sido restablecida, hemos enviado a su casilla de email (" +
                  username +
                  ") la nueva contraseña."
              )}
              <br />
              <br />
              {window.innerWidth <= 768 &&
                translate("Inicie sesión en la aplicación de Adium")}
            </>
          );
        } else if (response.data.error === true) {
          setInfo(
            <>
              {translate(
                "El enlace para restablecer tu contraseña ya ha sido utilizado.{0}Para generar un nuevo enlace, por favor solicita nuevamente el cambio de contraseña desde la app de Adium.{0}Si necesitas ayuda adicional, no dudes en contactarnos a {1} o a nuestro Whatsapp {2}.",
                <br />,
                <a href="mailto:soporte@motivia.co">soporte@motivia.co</a>,
                <a
                  href="https://wa.me/5491134056615?text=Hola,%20necesito%20ayuda%20para%20cambiar%20la%20contrase%C3%B1a"
                  target="_blank"
                >
                  +5491134056615
                </a>
              )}
            </>
          );
        }
        setValidating(false);
      } catch (error) {
        setValidating(false);
        console.log(error);
        setError(error.message);
      }
    };
    verifyData();
  }, [username, code]);

  return (
    <>
      <div className="flex flex-row w-screen justify-center items-stretch min-h-full max-w-7xl py-24">
        <div className="wfull md:w-1/2 flex justify-center">
          <Card
            title={translate("Cambio de contraseña")}
            className={`w-full ${!info ? "lg:w-7/12" : ""}`}
            bordered={false}
            headStyle={{ border: "none" }}
          >
            {error !== "" && <div className="text-custom_red">{error}</div>}
            {success !== "" && <div>{success}</div>}
            {info !== "" && <div className="text-center">{info}</div>}
          </Card>
        </div>
      </div>
      {validating && <FullPageLoader />}
    </>
  );
};

export default ForgotPasswordVerificationCode;
